module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAAnCAYAAACv+ADgAAAAAXNSR0IArs4c6QAAALFJREFUaEPtmbENgCAURDFuwQIUzMH+FSuQsIOF0UQTE5uzOTDP+vD+f4+OJaW09d7X8KNvuZaKMf5irdZauJeqtYbZF8s5B5aa4W5iagZLx4yYwpSRANfPCF+qxpSEyxjGlBG+VI0pCZcxjCkjfKkaUxIuYxhTRvhSNaYkXMYwpozwpWpMSbiMYUwZ4UvVmJJwGcOYMsKXql9NSX8YMFxKeb4kDjjj55HON9/Ppwc9uAMPqnWig45F2gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page/crop/four-to-three.png
// module id = NVq/
// module chunks = 3